export default __webpack_public_path__ + "static/media/review5.9b428590.jpg";